import { IApkState } from './apkContext';
import { ApkActionTypes, TApkActions } from './apkActions';

export const apkReducer = (state: IApkState, action: TApkActions): IApkState => {
	switch (action.type) {
		case ApkActionTypes.SET_APK:
			return {
				...state,
				apk: action.payload.apk,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ApkActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ApkActionTypes.SET_ID_APK_TYPE:
			return {
				...state,
				IDSelectedApkType: action.payload.IDSelectedApkType,
				currentPage: 1,
			};
		case ApkActionTypes.TOGGLE_UNASSIGNED_APK:
			return {
				...state,
				isUnassignedApk: !state.isUnassignedApk,
				currentPage: 1,
			};
		case ApkActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedApkType: null,
				currentPage: 1,
				isUnassignedApk: false,
			};
		case ApkActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ApkActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ApkActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ApkActionTypes.SET_APK_ID_FOR_DELETION:
			return {
				...state,
				apkIDForDeletion: action.payload.apkIDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ApkActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		case ApkActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
